module.exports = __webpack_public_path__ + "img/jxk_bjgz.35e1dea4.svg";